import { formatDate } from '@angular/common';
import { Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent, DataBindingDirective } from '@progress/kendo-angular-grid';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { ICustomer, IMultiplierPlan, IMultiplierPlanLabel, Multiplier } from '../../../core/models';
import { CommonService } from '../../../core/services/common.service';
import { CustomerService } from '../../../core/services/customer.service';
import { QuoteService } from '../../../core/services/quote.service';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from "exceljs";
import * as fs from 'file-saver';


import { UserService } from '../../../core/services/user.service';
import { LanguageTranslationService } from '../../../core/services/language-translation.service';
import { filter } from 'rxjs/operators';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
@Component({
  selector: 'app-customer-multiplier-plan',
  templateUrl: './customer-multiplier-plan.component.html',
  styleUrls: ['./customer-multiplier-plan.component.scss']
})
export class CustomerMultiplierPlanComponent implements OnInit {
  multiplierHeader: ICustomer;
  multiplierGridView: GridDataResult;
  public gridData: Multiplier[] = [];
  loadingPDF: boolean;
  loadingExcel: boolean;
  multiplierLoading: boolean;
  @ViewChildren(DataBindingDirective) dataBinding: DataBindingDirective;
 // @ViewChild(DataBindingDirective, { static: false }) dataBinding: DataBindingDirective;
  constructor(private customerService: CustomerService, private commonService: CommonService, private quoteService: QuoteService,
    private userService: UserService, private languageTranslationService: LanguageTranslationService  ) { }

  ngOnInit() {
    this.loadLanguageTranslationData();
    this.multiplierLoading = true;
    this.customerService.getMultiplierPlan().subscribe((response) => {
      this.multiplierHeader = response.customerAddress;
      if (response.multiplierPlans) {
        this.gridData = response.multiplierPlans;
        this.loadMultiplierGrid();
      }
    this.multiplierLoading = false;
    })
  }
  //#regin date format
  formatDate() {
    //const dateObj = new Date();
    //var year = dateObj.getFullYear();
    //var month = (1 + dateObj.getMonth()).toString();
    //month = month.length > 1 ? month : '0' + month;
    //var day = dateObj.getDate().toString();
    //day = day.length > 1  ? day : '0' + day;
    //return month + '/' + day + '/' + year;
    var currentDate = new Date();
    var twoDigitMonth = (currentDate.getMonth() + 1);
    var twoDigitDate = ((currentDate.getDate()) < 9) ? "0" + (currentDate.getDate()) : currentDate.getDate();
    var createdDateTo = twoDigitMonth + '/' + twoDigitDate+'/'+currentDate.getFullYear();
    return createdDateTo;
  }
  //#endregion
  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "customerNumberLbl" },
      { controlName: "territoryCodeLbl" },
      { controlName: "multiplierLbl1" },
      { controlName: "multiplierLbl2" },
      { controlName: "multiplierLbl3" },
      { controlName: "multiplierLbl4" },
      { controlName: "multiplierLbl5" },
      { controlName: "itemGroupLbl" },
      { controlName: "descriptionLbl" },
      { controlName: "itemGroupMultiplierLbl" },
      { controlName: "exportToPdfLbl" },
      { controlName: "exportToExcelLbl" },
      { controlName: "headingLbl" },
      { controlName: "footarTextLbl" },
    ];
    const componentName = "cmp";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.multiplierLabel = response[response.length - 1];
      console.log(response);
    }

  }
  multiplierLabel: IMultiplierPlanLabel = {
    customerNumberLbl: '',
    territoryCodeLbl: '',
    multiplierLbl1: '',
    multiplierLbl2: '',
    dateText: this.formatDate(),
    multiplierLbl3: '',
    multiplierLbl4: '',
    multiplierLbl5: '',
    itemGroupLbl: '',
    descriptionLbl: '',
    itemGroupMultiplierLbl: '',
    exportToPdfLbl: '',
    exportToExcelLbl: '',
    headingLbl: '',
    footarTextLbl: '',
  }
  //#region label declaration
  multiplierPlan = {
    customerNumberLbl: "Customer Number",
    territoryCodeLbl: "Territory Code",
    multiplierLbl1: "These Multipliers are for the stated price book finishes only.",
    multiplierLbl2: "Multiplier Plan generated on",
    dateText: this.formatDate(),
    multiplierLbl3: "Terms are 1% 10th 25th Net 30 Days",
    multiplierLbl4: "All material F.O.B. plant(s) or service centers(s)",
    multiplierLbl5: "This schedule supercedes all prior multiplier schedules",
    itemGroupLbl: "Item Group",
    descriptionLbl: "Item Group Description",
    itemGroupMultiplierLbl: "Item Group Multiplier",
    exportToPdfLbl: "Export to PDF",
    exportToExcelLbl: "Export To Excel",
    headingLbl: "Customer Multiplier",
    footarTextLbl:"©1991-2021 Arconic. All rights reserved"
  }

  
  //Need name refactor
  //multiplierText = {
  //  label1:"These Multipliers are for the stated price book finishes only.",
  //  label2: "Multiplier Plan generated on",
  //  dateText: this.formatDate(), 
  //  label3:"Terms are 1% 10th 25th Net 30 Days",
  //  label4:"All material F.O.B. plant(s) or service centers(s)",
  //  label5:"This schedule supercedes all prior multiplier schedules",
  //}
  //#endregion
  //#region multiplier grid functions and operations
  //multiplierGrid = {
  //  itemGroupLbl: "Item Group",
  //  description: "Item Group Description",
  //  itemGroupMultiplier: "Item Group Multiplier",
  //  exportPdf: "Export to PDF",
  //  exportExcel:"Export To Excel"
  //}
  protected loadMultiplierGrid() {
    this.multiplierGridView = process(this.gridData, this.multiplierGridstate);
  }
  //#endregion
  //#region sorting,filtering,pagination of grid
  protected multiplierGridstate: State = {
    sort: [],
    skip: 0,
    take: 10,
    group: [],
    filter: null,
  };
  protected multiplierGridSortChange(sort): void {
    this.multiplierGridstate.sort = sort;
    this.loadMultiplierGrid();
  }
  protected multiplierGridPageChange({ skip, take }: PageChangeEvent): void {
    this.multiplierGridstate.skip = skip;
    this.multiplierGridstate.take = take;
    this.loadMultiplierGrid();

  }
  protected multiplierDataStateChange(state: DataStateChangeEvent): void {
    this.multiplierGridstate = state;
    this.loadMultiplierGrid();
  }

  //#endregion
  //#region Grid Pdf and excel export functions
  async generateMultiplierPDF() {
    this.loadingPDF = true;
    var currFilter = this.multiplierGridstate.filter;
    var filterData = process(this.gridData, {
      filter: currFilter
    });

    var todaysDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    let docDefinition = {
      header: {
        columns: [
          { text: todaysDate, margin: [10, 12, 10, 20] },
          { text: 'Customer Multiplier', alignment: 'center', margin: [10, 12, 0, 20] }
        ]
      },
      content: [
        {         
          image: await this.commonService.getBase64ImageFromURL(
            location.origin.toString() + "/assets/images/kawneer_logo.JPG"
          ),
          alignment: 'center', fit: [150, 150]
        },
        //{
        //  text: this.userService.readUserObject.customerName,
        //  bold: true,
        //},
        //{
        //  text: this.multiplierHeader.addressLine1 + "" +
        //    this.multiplierHeader.city + "" + this.multiplierHeader.state + "" + this.multiplierHeader.zipCode,
        //  bold: true,
        //},
        //{
        //  text: "Customer Number :" + this.userService.readUserObject.customerNumber,
        //  bold: true,
        //  alignment: "right",
        //},
        {
          text: "Customer Number: " + this.userService.readUserObject.customerNumber,
          bold: true,
          margin: [0, 15, 0, 15]
        },
        {
          text: "Customer Name: " + this.userService.readUserObject.customerName,
          bold: true,
          margin: [0, 15, 0, 15]
        },
        {
          text: "Territory Code: " + this.multiplierHeader.territoryCode,
          bold: true,
          margin: [0, 15, 0, 15],         
        },
        {
          text: this.multiplierPlan.multiplierLbl1,
          style: 'sectionHeader'
        },

        {
          table: {
            headerRows: 1,
            body: [
              [this.multiplierPlan.itemGroupLbl,
                this.multiplierPlan.descriptionLbl,
                this.multiplierPlan.itemGroupMultiplierLbl             
              ],
              ...filterData.data.map(p =>
                ([
                  p.itemGroup ? p.itemGroup : '',
                  p.itemGroupDescription ? p.itemGroupDescription : '',
                  p.itemGroupMultiplier ? p.itemGroupMultiplier : '',
                  
                ])
              )
            ]
          
          }
        }
      ],
      footer: {
        columns: [
          { text: '©1991-2021 Arconic. All rights reserved.', alignment: 'center' }
        ]
      },
      styles: {
        sectionHeader: {
          bold: true,
          decoration: 'underline',
          fontSize: 14,
          margin: [0, 15, 0, 15]
        }
      }
    };

    pdfMake.createPdf(docDefinition).download('multiplier-plan.pdf');
    this.loadingPDF = false;

  }
  generateMultiplierExcel() {
    this.loadingExcel = true;
    var currFilter = this.multiplierGridstate.filter;
    var filterData = process(this.gridData, {
      filter: currFilter
    });
    let workbook: ExcelProper.Workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Customer Multiplier');
    const header = [this.multiplierPlan.itemGroupLbl,
      this.multiplierPlan.descriptionLbl,
      this.multiplierPlan.itemGroupMultiplierLbl];
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    let ClientIdRow = worksheet.addRow(['Customer Number :' + this.userService.readUserObject.customerNumber + '']);
    ClientIdRow.font = { size: 10, bold: true }
    worksheet.addRow([]);
    let ClientNameRow = worksheet.addRow(['Customer Name :' + this.userService.readUserObject.customerName + '']);
    ClientNameRow.font = { size: 10, bold: true }
    worksheet.addRow([]);
    let territoryCode = worksheet.addRow(['Territory Code:' + this.multiplierHeader.territoryCode + '']);
    territoryCode.font = { size: 10, bold: true }
    worksheet.addRow([]);
    worksheet.addRow([]);

    let invoiceDetailsRow = worksheet.addRow(['Customer Multiplier']);
    invoiceDetailsRow.font = { size: 10, underline: 'double', bold: true };
    //Add Header row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    filterData.data.map(p =>
      ([
        p.itemGroup ? p.itemGroup : '',
        p.itemGroupDescription ? p.itemGroupDescription : '',
        p.itemGroupMultiplier ? p.itemGroupMultiplier : '',
      ])
    ).forEach(d => {
      let row = worksheet.addRow(d);
    });
    worksheet.addRow([]);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'multiplier-plan.xlsx');
      this.loadingExcel = false;
    })
  }
  //#endregion
  public onFilter(inputValue: string): void {

    this.multiplierGridView = process(this.gridData, {
      filter: {
        logic: "or",
        filters: [
          {
            field: "itemGroup",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "itemGroupDescription",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "itemGroupMultiplier",
            operator: "contains",
            value: inputValue,
          },
        ],
      },
    });
    if (!inputValue) {
      this.multiplierGridstate.skip = 0;
      this.multiplierGridstate.take = 10;
      this.loadMultiplierGrid();
    }
    //debugger;
    //this.dataBinding.skip = 0;
  }
}
